import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import Header from '@components/Header';  
import JustificationModal from '@components/JustificationModal';
import AddOficialCumplimiento from '@components/RolesProess/AddOficialCumplimiento';

import { getListRoles, getListUsersByRole, addUserIntoRole, addCocUserIntoRole, updateUserIntoRole, deleteRoleUser, assignPrincipalUser, getRegion } from '@actions/rolesProcess'
import { sendActionToBitacora  } from '@actions/bitacora';
import { getBusiness } from '@actions/business';

import { StatusConst, StatusPrincipal } from '@constants/general';
import { getValueLanguageObj } from '@utils/general'

import { SET_VALUES_ADMIN } from '@constants/actionType'

import store from '@store'

// import './style.scss'

const ROLE_GROUP_COC = 'coc';
const ROLE_OFICIAL_CUMPLIMIENTO_ID = 3;
const ROLE_AUXILIAR_PDD_ID = 14;
const ROLE_AUXILIAR_OC_ID = 16;
const EDITABLE_ROLE_IDS = [3, 11];

class Roles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      roleSelected: null,
      selectedNodeKeys: null,
      selectedKeys: null,
      treeNodeKeys: null,
      paisesSelected: null,
      roles: [],
      regiones: [],
      catalogBusiness: [],
      complianceOfficers: [],
      users: [],
      loadingTable: false,
      modalAddOficialCumplimiento: false,
      titleModalAddRole: '',
      btnLoadingSubmit: false,
      userSelect: false,
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
      pageFirst: 0
    };
  }

  async componentDidMount() {
    await this.onGetRolesProcess()
    await this.onGetRegiones()
    await this.seCompaniesByCountry()
    await this.onChangeEvaluator({target: {name: 'roleSelected', value: this.state.roles[0]}})
    this.setState({loadingPage: false})
  }

  seCompaniesByCountry = async () => {
    const { getBusiness } = this.props
    this.setState({catalogBusiness: []})
    const params = {
      type: 'visible'
    };
    const response = await getBusiness(params);
    if (!response?.status) {
      const catalogBusiness = response.data.map(item => ({ label: item.nombre, id: item.id, id_pais: item.id_pais }))
      return this.setState({catalogBusiness})
    }

  }

  onGetRolesProcess = async () => {
    const { getListRoles } = this.props
    const catAmx = 'amx';
    const catSp = 'sp';
    const catPer = 'per';
    const catCoc = ROLE_GROUP_COC;
    const responseAmx = await getListRoles(catAmx)
    const responseSp = await getListRoles(catSp)
    const responsePer = await getListRoles(catPer)
    const responseCoc = await getListRoles(catCoc)

    let roles = [];
    if (responseAmx?.data) {
      roles = responseAmx?.data
    }
    
    if (responseSp?.data && responseSp.data.length) {
      roles = roles.concat(responseSp?.data)
    }

    if (responsePer?.data && responsePer.data.length) {
      roles = roles.concat(responsePer?.data)
    } 

    if (responseCoc?.data && responseCoc.data.length) {
      roles = roles.concat(responseCoc.data.filter(role =>
        [ROLE_AUXILIAR_PDD_ID, ROLE_AUXILIAR_OC_ID].includes(Number(role.id))
      ))
    }

    roles = roles.sort((roleA, roleB) =>
      (roleA.nombre || '').localeCompare(roleB.nombre || '', 'es', { sensitivity: 'base' })
    )

    this.setState({roles})
      
    return roles
  }

  onGetRegiones = async () => {
    const { getRegion } = this.props
    const response = await getRegion()
    this.setState({regiones: response})
    
    return response
  }

  onGetUsersByRole = async () => {
    const { getListUsersByRole } = this.props
    const { roleSelected } = this.state
    const response = await getListUsersByRole(roleSelected.id)
    const users = Array.isArray(response?.data) ? response.data : []
    this.setState({users})
    return response
  }

  onGetComplianceOfficers = async () => {
    const { getListUsersByRole } = this.props
    const response = await getListUsersByRole(ROLE_OFICIAL_CUMPLIMIENTO_ID, 'active')
    const complianceOfficers = Array.isArray(response?.data) ? response.data : []
    this.setState({complianceOfficers})
    return response
  }

  onAddUserIntoRole = async (data, justification) => {
    const { addUserIntoRole, addCocUserIntoRole, sendActionToBitacora, updateUserIntoRole } = this.props
    const { roleSelected, userSelect } = this.state
    this.setState({btnLoadingSubmit: true})
    const newData = {
      ...data,
      id_rol: roleSelected.id
    }

    const isCoordinatedAssistant = this.isCoordinatedAssistant(roleSelected)
    const response = userSelect ? await updateUserIntoRole(newData) : isCoordinatedAssistant ? await addCocUserIntoRole(newData) : await addUserIntoRole(newData)
    if (!response?.status) {
      const dataBitacora = {
        transactionName: userSelect ? 'actualizaRolProceso' : 'altaRolProceso',
        reason: `${data.correo} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      this.onGetUsersByRole()
      this.onShowModalAddOficialCumplimiento(false)
    }


    this.setState({btnLoadingSubmit: false})
  }

  onDeleteUserIntoRole = async (data, justification) => {
    const { deleteRoleUser, sendActionToBitacora } = this.props
    const { roleSelected } = this.state
    this.setState({btnLoadingSubmit: true})
    const newData = {
      correo: data.correo,
      id_rol: roleSelected.id
    }
    const response = await deleteRoleUser(newData)
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'bajaRolProceso',
        reason: `${data.correo} || ${justification}`,
      }

      await sendActionToBitacora(dataBitacora)
      this.onGetUsersByRole()
      this.onShowModalAddOficialCumplimiento(false)
    }
    this.setState({btnLoadingSubmit: false})
  }

  onAssignPrincipalUser = async (data, justification) => {
    const { assignPrincipalUser, sendActionToBitacora } = this.props
    const { roleSelected } = this.state
    this.setState({btnLoadingSubmit: true})
    const newData = {
      correo: data.correo,
      id_rol: roleSelected.id
    }
    const response = await assignPrincipalUser(newData)
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'asignaUsuarioPrincipal',
        reason: `${data.correo} || ${justification}`,
      }

      await sendActionToBitacora(dataBitacora)
      this.onGetUsersByRole()
      this.onShowModalAddOficialCumplimiento(false)
    }
    this.setState({btnLoadingSubmit: false})
  }

  onChangeEvaluator = async ({target}) => {
    this.setState({
      [target.name]: target.value,
      pageFirst: 0
    }, () => this.onGetUsersByRole());
  };

  
  onShowModalAddOficialCumplimiento = async (value) => {
    const { t } = this.props
    const { roleSelected, userSelect, selectedNodeKeys } = this.state
    const selectedNKeys = userSelect ? selectedNodeKeys : null
    this.setState({
      modalAddOficialCumplimiento: value,
      selectedNodeKeys: selectedNKeys,
      titleModalAddRole: `${roleSelected.nombre}`,
    })
    if (value && this.isCoordinatedAssistant(roleSelected)) {
      await this.onGetComplianceOfficers()
    }
    if(roleSelected.id === 11 && value){
      window.scrollTo(0, 0)
    } else if(!userSelect){
      window.scrollTo(0, document.body.scrollHeight);
    }
  }

  showDeleteUser = async (detail) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea eliminar {{ELEMENTO}}?', {ELEMENTO: detail.nombre}),
        continueAction: ({justification}) => this.onDeleteUserIntoRole(detail, justification),
      },
    });
  };

  showUpdUserPrin = async (detail) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea modificar a {{ELEMENTO}} como principal?', {ELEMENTO: detail.nombre}),
        continueAction: ({justification}) => this.onAssignPrincipalUser(detail, justification),
      },
    });
  };

  adminsTemplate = (rowData, detail) => {
    const { t } = this.props
    if (rowData?.admin_paises === "ALL") return (
      <>
          <span className="p-column-title">{detail.header}</span>
          {t('Todos los países')}
      </>
    )
    const getCountries = rowData.paises.map(item => getValueLanguageObj(JSON.parse(item.nombre)))
    const countries = getCountries.join(', ')
    return (
      <>
          <span className="p-column-title">{detail.header}</span>
          {countries}
      </>
    )
  }

  columnResponsive = (rowData, detail) => {
    const {roleSelected} = this.state
    let valueSpace = rowData[detail.field]
    if(/[A-Z]/.test(rowData[detail.field]) 
        && detail.field === 'correo' && roleSelected.id === 11){
      valueSpace = rowData[detail.field].replace('@',' @')
    }
    return (
    <>
        <span className="p-column-title">{detail.header}</span>
        {valueSpace}
    </>
  )}

  coordinatorTemplate = (rowData, detail) => (
    <>
      <span className="p-column-title">{detail.header}</span>
      {rowData.nombre_coordinador || ''}
    </>
  )

  countriesTemplate = (rowData, detail) => {
    const { t } = this.props
    if (rowData?.admin_paises === "ALL") return (
      <>
          <span className="p-column-title">{detail.header}</span>
          {t('Todos los países')}
      </>
    )
    const getCountries = rowData.paises.map(item => getValueLanguageObj(JSON.parse(item.nombre)))
    const countries = getCountries.join(', ')
    return (
      <>
          <span className="p-column-title">{detail.header}</span>
          {countries}
      </>
    )
  }

  companiesTemplate = (rowData, detail) => {
    const { t } = this.props
    if (rowData?.admin_empresas === "ALL" ) return (
      <>
          <span className="p-column-title">{detail.header}</span>
          {t('Todas las empresas')}
      </>
    )

    const getCountries = []
    
    rowData.paises.filter(item => item.empresas).map(item => {
      item?.empresas?.map(emp => {
        getCountries.push(emp.nombre)
      })
    })
    const countries = getCountries.join(', ')
    return (
      <>
          <span className="p-column-title">{detail.header}</span>
          {countries}
      </>
    )
  }

  countriesIdTemplate = (rowData, detail) => {
    const { t } = this.props
    if (rowData?.admin_paises === "ALL") return (
      <>
          <span className="p-column-title">{detail.header}</span>
          {t('Todos los países')}
      </>
    )

    const getCountries = []
    
    rowData.paises.filter(item => item.empresas).map(item => {
      item?.empresas.filter(emp => emp.regiones)?.map(emp => {
        emp?.regiones?.map(reg => {
          getCountries.push(reg.id)
        })
      })
    })
    const countries = getCountries.join(', ')
    return (
      <>
          <span className="p-column-title">{detail.header}</span>
          {countries}
      </>
    )
  }

  templatePrincipal = (node, detail) => {
    if (node.principal === StatusPrincipal.IS_PRINCIPAL) {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <i className="pi pi-check p-mr-2 p-text-bold"></i>
        </div>
      )
    } else {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <Button
            icon="pi pi-times-circle"
            className=" p-button-text p-button-primary p-mr-2"
            onClick={() => this.showUpdUserPrin(node)}
          />
        </div>
      )
    }

    return (
      <>
        <span className="p-column-title detalles-head">{detail.header}</span>
      </>
    )
  }

  templateStatus = (node, detail) => {
    const { t } = this.props
    if (node.estatus === StatusConst.IS_ACTIVE) {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <i className="pi pi-check p-mr-2"></i>
        </div>
      )
    } else if (node.estatus === StatusConst.IS_SUSPENDED) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-red"> {t('SUSPENDIDO')} </span>
        </>
      )
    }
  }

  editAdmin = async (data) => {
    await store.dispatch({
      type: SET_VALUES_ADMIN,
      payload: {user: data}
    })

    const nodeRegion = await this.selectRegion(data)

    this.setState({userSelect: true, selectedNodeKeys: nodeRegion})
    this.onShowModalAddOficialCumplimiento(true)
  }

  editTemplate = (rowData, detail) => (
    <>
      <span className="p-column-title">{detail.header}</span>
      <Button
        icon="pi pi-pencil"
        className=" p-button-text p-button-primary p-mr-2"
        onClick={() => this.editAdmin(rowData)}
      />
    </>
  );

  deleteTemplate = (rowData, detail) => (
    <>
      <span className="p-column-title">{detail.header}</span>
      <Button
        icon="pi pi-trash"
        className=" p-button-text p-button-primary p-mr-2"
        onClick={() => this.showDeleteUser(rowData)}
      />
    </>
  );

  selectRegion = async (user) => {
    if(user){
      let objectSel = {}
      user?.paises?.map(country => {
        const isCountryAll = false
        objectSel[`P${country.id}`] = { checked: false, partialChecked: true}
        country?.empresas?.map(company => {
          const isCompanieAll = company?.regiones?.length ? false : true
          objectSel[`P${country.id}-E${company.id}`] = { checked: isCompanieAll, partialChecked: !isCompanieAll}
          company?.regiones?.map(region => {
            objectSel[`P${country.id}-E${company.id}-R${region.id}`] = { checked: true, partialChecked: false}
          })
        })
      })
      
      return objectSel
    }
  };

  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  setSelectedNodeKeys = (value) => {
    
    const keysValR = Object.keys(value)?.filter(k => k.includes('-R'))
    const keysValE = Object.keys(value)?.filter(k => k.includes('-E') && !k.includes('-R'))
    const keysValP = Object.keys(value)?.filter(k => !k.includes('-E') && !k.includes('-R'))
    
    let lstPaises = []
    keysValP?.map(p => {
      const pais = {id: p.substring(1), empresas: []}
      const empresasK = keysValE?.filter(e => e.startsWith(p + '-'))
      let lstEmpresas = []
      empresasK?.map(e => {
        const indexEmp = e.indexOf('-E') + 2
        const empresa = {id: e.substring(indexEmp), regiones: []}
        empresa.regiones = keysValR.filter(r => r.includes(e + '-'))?.map(r => {
          const indexReg = r.indexOf('-R') + 2
          return {id: r.substring(indexReg)}
        })
        lstEmpresas.push(empresa)
      })
      pais.empresas = lstEmpresas
      lstPaises.push(pais)
    })

    this.setState({selectedNodeKeys: value, paisesSelected: lstPaises})
  }

  canEditRole = (roleId) => EDITABLE_ROLE_IDS.includes(Number(roleId))

  canAssignPrincipal = (roleId) => Number(roleId) === ROLE_OFICIAL_CUMPLIMIENTO_ID

  isCoordinatedAssistant = (role) =>
    [ROLE_AUXILIAR_PDD_ID, ROLE_AUXILIAR_OC_ID].includes(Number(role?.id))

  render() {
    const { history, t } = this.props;
    const { loadingPage, roles, regiones, roleSelected, users, loadingTable, modalAddOficialCumplimiento, userSelect,
      btnLoadingSubmit, titleModalAddRole, showModalJustification, selectedNodeKeys, catalogBusiness, paisesSelected,
      complianceOfficers, pageFirst } = this.state;

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
      </>
    );

    if (loadingPage) return true
    const isCoordinatedAssistant = this.isCoordinatedAssistant(roleSelected)
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Roles en proceso')} rightComponent={rightHeader} />
          <div className="card">
            <div className="p-col-12 p-mt-2">
              <label className="">{t('Roles en procesos')}:</label>
              <Dropdown
                name="roleSelected"
                value={roleSelected}
                options={roles}
                onChange={this.onChangeEvaluator}
                optionLabel="nombre"
                className="p-mt-2"
                placeholder=""
                style={{ width: '100%' }}
              />
            </div>
            { roleSelected && (
              <>
                <div className="p-col-12">
                  <DataTable
                    value={users}
                    //lazy
                    className="table-languages"
                    emptyMessage={
                      <div className="p-d-flex p-jc-center p-py-3">
                        <span>
                          {t("No se encontraron usuarios asignados al rol")} {roleSelected?.nombre}
                        </span>
                      </div>
                    }
                    loading={loadingTable}
                    stripedRows
                    paginator={users.length > 0}
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" 
                    rows={10} 
                    rowsPerPageOptions={[10,20,50]}
                    totalRecords={users.length}
                    onPageChange={(e) => {console.log('pageevent', e)}}
                    first={pageFirst}
                  >
                    {!isCoordinatedAssistant &&
                      <Column
                      header={t('País')}
                      field="correo"
                      body={this.countriesTemplate}
                      // className="column-action p-mr-4"
                      style={{ width: '12%' }}
                      />
                    }
                    {roleSelected.id === 11 && 
                      <Column
                        header={t('Empresa')}
                        field="correo"
                        body={this.companiesTemplate}
                        // className="column-action p-mr-4"
                        style={{ width: '12%' }}
                      />
                    }
                    {roleSelected.id === 11 && 
                      <Column
                        header={t('Región')}
                        field="correo"
                        body={this.countriesIdTemplate}
                        // className="column-action p-mr-4"
                        style={{ width: '12%' }}
                      />
                    }
                    <Column
                      header={t('Nombre')}
                      field="nombre"
                      body={this.columnResponsive}
                      style={{ width: '15%' }}
                    />
                    <Column
                      header={t('Correo electrónico')}
                      field="correo"
                      body={this.columnResponsive}
                      // className="column-action p-mr-4"
                      style={{ width: '20%' }}
                    />
                    {isCoordinatedAssistant &&
                      <Column
                        header={t('Oficial de Cumplimiento')}
                        field="nombre_coordinador"
                        body={this.coordinatorTemplate}
                        style={{ width: '20%' }}
                      />
                    }
                    {this.canAssignPrincipal(roleSelected.id) && 
                      <Column
                        header={t('Principal')}
                        body={this.templatePrincipal}
                        className="p-text-center-lg"
                        style={{ width: '7%' }}
                      />
                    }
                    <Column
                      header={t('Estatus')}
                      body={this.templateStatus}
                      className="p-text-center-lg"
                      style={{ width: '7%' }}
                    />
                    {this.canEditRole(roleSelected.id)&& 
                      <Column
                        header={t('Editar')}
                        body={this.editTemplate}
                        className="p-text-center-lg"
                        style={{ width: '7%' }}
                      />
                    }
                    <Column
                      header={t('Eliminar')}
                      body={this.deleteTemplate}
                      className="p-text-center-lg"
                      style={{ width: '7%' }}
                    />
                  </DataTable>
                </div>
                <div className="p-col-12 p-d-flex p-jc-end">
                    <Button
                      label={`${t('Agregar')  } ${roleSelected.nombre}`}
                      type="button"
                      className="p-button-primary"
                      onClick={() => {
                        this.setState({userSelect: false})
                        this.onShowModalAddOficialCumplimiento(true)
                      }}
                      // loading={btnSubmitLoading}
                    />
                </div>
              </>
            )}
          </div>
        </div>
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.onHideModal()}
          onContinueAction={showModalJustification.continueAction}
        />
        <Toast ref={(el) => (this.toast = el)} />
        { modalAddOficialCumplimiento && (
          <AddOficialCumplimiento
            userSelect={userSelect}
            regiones={regiones}
            catalogBusiness={catalogBusiness}
            complianceOfficers={complianceOfficers}
            title={titleModalAddRole}
            roleSelected={roleSelected.id}
            paisesSelected= {paisesSelected}
            selectedNodeKeys={selectedNodeKeys}
            setSelectedNodeKeys={this.setSelectedNodeKeys}
            onHidden={() => this.onShowModalAddOficialCumplimiento(false)}
            onAction={this.onAddUserIntoRole}
            btnLoading={btnLoadingSubmit}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loadingEvaluator: state.evaluator.loadingEvaluator,
  evaluatorId: state.evaluator.id,
});

const mapDispatchToProps = {
  getListRoles,
  getRegion,
  getBusiness,
  getListUsersByRole,
  addUserIntoRole,
  addCocUserIntoRole,
  updateUserIntoRole,
  deleteRoleUser,
  assignPrincipalUser,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Roles);
